module.exports = __webpack_public_path__ + "static/media/create_reservation_home.298a3dfd.jpg";